function last<T>(array: T[]): T;
function last<T>(array: [T, ...T[]]): T;
function last<T>(array: unknown[]): unknown {
  return array[array.length - 1] as T;
}

export default last;
